/// <amd-module name="CodeCoverage/Common/Common" />
import { ICodeCoverageTimelineSummaryData } from "CodeCoverage/Common/Interfaces/ICodeCoverageTimelineSummaryData";
import { RunViewArtifact } from "CodeCoverage/Common/RunViewArtifact";
import { CodeCoverageSource } from "Sources/CodeCoverageSource";
import { CodeCoverageData, CodeCoverageSummary } from "Test/common-util/Contracts/Test";
import * as Utils_String from "VSS/Core/Util/String";
import { BuildStatus } from "Build/Client/Contracts/Build";

export const GetCodeCoverageTimelineSummaryData = (
    runViewArtifact: RunViewArtifact,
    codeCoverageSource: CodeCoverageSource
): Promise<ICodeCoverageTimelineSummaryData[]> => {
    if (runViewArtifact.buildStatus == BuildStatus.Completed) {
        return codeCoverageSource.getCodeCoverageSummary(runViewArtifact).then(
            (summary: CodeCoverageSummary) => {
                if (summary) {
                    const timelineSummaryData = _generateSummaryDataFromCoverageData(summary.coverageData) as ICodeCoverageTimelineSummaryData[];
                    return timelineSummaryData || [];
                } else {
                    console.warn("getCodeCoverageSummary promise returned null");
                    return [];
                }
            },
            (error: any) => {
                console.error(error);
                return [];
            }
        );
    } else {
        return Promise.resolve([]);
    }
};

const _generateSummaryDataFromCoverageData = (coverageData: CodeCoverageData[]): ICodeCoverageTimelineSummaryData[] => {
    const timelineSummaryData: ICodeCoverageTimelineSummaryData[] = [];

    if (!coverageData) {
        return [];
    }

    coverageData.forEach(data => {
        const lineStats = data.coverageStats.filter(
            value =>
                value.label &&
                (!Utils_String.localeIgnoreCaseComparer(value.label, "Lines") || !Utils_String.localeIgnoreCaseComparer(value.label, "Line"))
        );

        if (lineStats.length) {
            const linesCovered = lineStats[0].covered || 0;
            const totalLines = lineStats[0].total || lineStats[0].covered;

            timelineSummaryData.push({
                buildConfiguration: data.buildFlavor,
                buildPlatform: data.buildPlatform,
                coveredPercentage: totalLines ? (linesCovered / totalLines) * 100 : 0
            } as ICodeCoverageTimelineSummaryData);
        }
    });

    return timelineSummaryData;
};
